import { useEffect } from 'react';
import { pageViewEvent } from '../../../tracking/tracking-utils';
import { pages } from '../../../tracking/constants';

export const useTracking = ({
  log,
  config,
  providerId,
  profile,
  slotsByProviderId,
  error,
  loading
}) => {
  const hasSlotsInState = slotsByProviderId && slotsByProviderId[providerId];

  useEffect(() => {
    if (hasSlotsInState && config.display_availability_in_search) {
      const { slots = [], apptInfo: { purpose, relationship } = {} } =
        slotsByProviderId[providerId];

      if (slots.length) {
        // profile page only displays avail-tiles if slots are returned (no unavailable view on profile)
        // therefore, only log if slots are returned
        log('user_action.profile.availability_tiles_displayed', {
          provider_id: providerId,
          slots: slots.length,
          purpose,
          relationship
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSlotsInState, config.display_availability_in_search]);

  useEffect(() => {
    /** We log a page view event when all of the following are satisfied: the provider data exists, there is no error, and we are not loading */
    if (profile && !error && !loading) {
      log(pageViewEvent(pages.PROVIDER_PROFILE));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, profile, loading]);
};
